import printButtonComponentModalCtrl from './printButtonComponentModalCtrl';
import printButtonComponentModalUrl from './printButtonComponentModal.html';
import printButtonComponentUrl from './printButtonComponent.html';
class PrintButtonCtrl {
  constructor($uibModal, $attrs) {
    'ngInject';

    Object.assign(this, { $uibModal, $attrs });
  }

  $onInit() {
    if ('print' in this.$attrs) {
      this.printBinding = this.print.bind(this);
    }
  }

  print() {
    this.$uibModal
      .open({
        size: '500',
        templateUrl: printButtonComponentModalUrl,
        controllerAs: 'ctrl',
        controller: printButtonComponentModalCtrl,
        resolve: {
          prepare: () => this.prepare,
          args: () => this.args,
          type: () => this.type,
          title: () => this.title,
          caption: () => this.caption,
          batchPrint: () => false,
        },
      })
      .result.ignoreCancel();
  }
}

export default {
  bindings: {
    type: '@',
    title: '@modalTitle',
    caption: '<?',
    prepare: '<?',
    args: '<?',
    tooltipPlacement: '@?',
    tooltipText: '@?',
    printBinding: '=?print',
    printBindingOnly: '=?',
    asText: '@?',
  },
  controller: PrintButtonCtrl,
  controllerAs: 'ctrl',
  templateUrl: printButtonComponentUrl,
};
